import type { FaireProductEntity } from "../../entity_types/product";

export const p_sen93vn6ny: FaireProductEntity = {
  token: "p_sen93vn6ny",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - HOT PINK",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/a200979897456ec0c188778fdea309ff58b0b5b1e1fa56719d4a6173ff6e1c7c.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This bubble skirt from Girlie Girl Originals brings bold color to your wardrobe. Styled for everyday wear or casual occasions, it pairs well with basic tops and accessories to create a standout look with southern flair.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:35.447Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
